//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            headers: ["Name", "Category", "Sort Order", "Allowed"],
            updateType: false,
            adding: false,
            baseUrl: "/api/paymentTypes",
            types: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        axios.get("" + this.baseUrl).then(function (response) {
            return _this.types = response.data;
        });
    },

    methods: {
        addNew: function addNew() {
            this.types.unshift({
                name: 'Category Name',
                category: 'Cash',
                allowed: 'Yes',
                sort_order: '0'
            });
            this.updateType = 0;
            this.adding = true;
            console.log(this.types);
        },
        save: function save(idx) {
            var _this2 = this;

            var row = this.types[idx];
            var data = {
                name: row.name,
                category: row.category,
                allowed: row.allowed,
                sort_order: row.sort_order
            };
            if (this.adding) {
                // add new item
                axios.post("" + this.baseUrl, data).then(function (response) {
                    _this2.updateTypes = false;
                    _this2.types[idx] = response.data;
                });
                this.updateType = 0;
                this.adding = false;
            } else {
                // update items
                axios.patch(this.baseUrl + "/" + row.id + "/", data).then(function (response) {
                    _this2.updateTypes = false;
                });
                this.$snotify.success('The items were updated');
            }
        },
        removeType: function removeType(idx) {
            var _this3 = this;

            axios.delete(this.baseUrl + "/" + this.types[idx].id + "/", { id: this.types[idx].id }).then(function (response) {
                _this3.updateTypes = false;
                _this3.types.splice(idx, 1);
                _this3.$snotify.error('The item was removed');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/properties/PaymentTypes.vue
// module id = bFlb
// module chunks = 0 1